import React from "react";
import { useEffect, useState } from "react";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { string } from "yup";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import { isNullOrEmpty } from "../../../../config/ENV";
import { JobService } from "../../../../services/JobService";
import ReactQuill from "react-quill";
import Linkify from "react-linkify";
import { MentionsInput, Mention } from "react-mentions";
import mentionsInputStyle from "../../../../assets/css/mentionsInputStyles";
import mentionStyle from "../../../../assets/css/mentionStyle";
import { showLocalDateTime } from "../../../../utilities/timeutility";
import moment from 'moment-timezone'




const AddNotes = (props) => {
  var { id } = useParams();
  const userId = window.localStorage.getItem("user");
  const [notesList, setNotesList] = useState([]);
  const [selectedNoteId, setSelectedNoteId] = useState("");
  const [notesAdded, setNotesAdded] = useState("");
  const [notename, setNotename] = useState("");
  const [jobStatus, setJobStatus] = useState("");
  const [users, setUsers] = useState([]);
  const [tausers, setTAusers] = useState(false);
  const [value, setValue] = useState("");
  const [userMentions, setUserMentions] = useState([]);
  const [talentAdvisors, setTalentAdvisors] = useState([]);
  const [notesId, setNotesId] = useState("");
  const [taSelectedNotes, setTaSelectedNotes] = useState("");
  const [modalBasic, setModalBasic] = useState(false);
  const [selectedUsers, setSelectedUSers] = useState([]);
  const [selectedMentions, setSelectedMentions] = useState([]);

  const history = useHistory();
  let count = 0;
  useEffect(() => {
    getTalentAdvisors();
    if (id !== "") {
      getNotes();
      getJobDetails(id);
    }
  }, [count]);

  const getNotes = () => {
    JobService.getJobNotes(id).then((response) => {
      if (response.status === 200) {
        setNotesList(response.data.notes);
      }
    });
  };

  const getTalentAdvisors = () => {
    JobService.getActiveTAService().then((response) => {
      try {
        if (response.data !== null) {
          setUsers(response.data.members);
          let arr = [];
          for (let i = 0; i < response.data.members.length; i++) {
            // arr.push(response.data.members[i].firstName )
            let obj = {
              id: response.data.members[i].id,
              display: response.data.members[i].displayName,
            };

            arr.push(obj);
          }
          // setTalentAdvisors(obj)
          setUserMentions(arr);
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err.message));
      }
    });
  };

  const getJobDetails = (jobId) => {
    try {
      var jobDetails = props.jobDetails;
      if (jobDetails != null) {
        if (jobDetails.jobStatus !== null || jobDetails.jobStatus !== "") {
          setJobStatus(jobDetails.jobStatus.key);
        }
      }
    } catch (err) {
      console.log("message" + JSON.stringify(err.message));
    }
  };

  const deleteNoteConfirmation = (note) => {
    setSelectedNoteId(note.id);
  };
  const handlePreviousButton = () => {
    props.parentCallback("skills");
  };
  const doneFunction = () => {
    history.push("/requests");
  };
  const deleteNote = () => {
    if (!isNullOrEmpty(id)) {
      JobService.deleteJobNotes(id, selectedNoteId).then((response) => {
        try {
          if (response.status === 200) {
            toast.success("Notes deleted successfully");
            getNotes();
            return;
          }
        } catch (err) {
          toast.error("User not authorized");
          console.log("error" + JSON.stringify(err.message));
        }
      });
    }
    return;
  };
  const addJobNotes = () => {
    const addedNotes = notesAdded;
    if (isNullOrEmpty(addedNotes) || !addedNotes.trim().length) {
      toast.error("Please enter notes");
      return;
    }
    const str = addedNotes;
    const message = str.replace(/@\[([^\]]+)\]\([^\)]+\)/g, "@$1");
    var arr = getSelectedusers(message);
    const notesObj = {
      commentedById: userId,
      notes: message,
      mentions:arr,
    };
    JobService.addJobNotes(notesObj, id).then((response) => {
      if (response.status === 200) {
        toast.success("Notes added successfully");
        getNotes();
        setNotesAdded("");
      }
    });

  

    // if (arr.length > 0) {
    //   const Obj = {
    //     ids: arr,
    //     description: message,
    //     contextId: id,
    //   };
     
    //   setSelectedUSers([]);
    //   JobService.addNotifications(Obj).then((response) => {
    //     if (response.status === 200) {
    //       setTimeout(() => {
    //         window.location.reload();
    //       }, 100);
    //     }
    //   });
    // }
  
  };

  const getSelectedusers = (input) => {
    var arr = [];
    if(selectedMentions.length>0){
       for(let i=0;i<selectedMentions.length;i++){
          let selectedMentionId=selectedMentions[i].id;
          arr.push(selectedMentionId);
       }
    }
    return arr;
  };

  const showDeleteButton = (note, indx) => {
    if (userId === note.commentedById) {
      if (note.autoGenerated === false && indx === 0) {
        return (
          <>
            <i
              className=" simple-icon-note edit-copyiconsize arrow-icon-color mr-2 emp_icon  t-cursor-pointer btn-sm"
              title="Edit Notes"
              outline
              color="primary"
              onClick={(e) => {
                UpdateTaNotes(note);
              }}
            />
            <i
              className="mb-2 simple-icon-trash edit-copyiconsize arrow-icon-color mr-1 emp_icon"
              data-toggle="modal"
              data-target="#deleteModal"
              color="primary"
              title="Delete Notes"
              outline
              onClick={() => deleteNoteConfirmation(note)}
            />
          </>
        );
      }
    }
    return;
  };
  

  const UpdateTaNotes = (note) => {
    setSelectedNoteId(note.id);

    setModalBasic(true);
    setTaSelectedNotes(note.notes);
  };

  const UpdateJobnotes = () => {
    if (isNullOrEmpty(taSelectedNotes)) {
      toast.error("Please add notes");
    }

    const str = taSelectedNotes;

    const message = str.replace(/@\[([^\]]+)\]\([^\)]+\)/g, "@$1");
    var arr = getSelectedusers(message);

    const UpdatenotesObj = {
      commentedById: userId,
      notes: message,
      mentions:arr,
    };

    JobService.updateJobNotes(UpdatenotesObj, id, selectedNoteId).then(
      (response) => {
        if (response.status === 200) {
          toast.success("Notes updated successfully");
          getNotes();
          setNotesAdded("");

          return;
        }
      }
    );

    setModalBasic(false);

    // if (selectedUsers.length > 0) {
    //   const Obj = {
    //     ids: arr,
    //     description: message,
    //     contextId: id,
    //   };
    //   JobService.addNotifications(Obj);
    //   setSelectedUSers([]);
    // }

    return;
  };
  const positionSuggestions = (
    mentionsClientRect,
    { caretClientRect, left, top }
  ) => {
    const { height: mentionHeight } = mentionsClientRect;
    const { height: caretHeight, width: caretWidth } = caretClientRect;
    return {
      top: top - mentionHeight - caretHeight,
      left: left + caretWidth / 2,
    };
  };

  const showNotesList = (notes) => {
    const showName = (name) => {
      if (name.includes("null")) {
        let Arr = [];
        Arr = name.split(" ");
        delete Arr[1];
        return Arr[0];
      }
      return name;
    };

    return (
      <>
        {notes.length > 0 &&
          notes.map((note, index) => {
            return (
              <div key={note.id}>
                <div className="">
                  <span>
                    <div>
                      <div className="row ">
                        <Col className="col-9 p-0">
                          <Col>
                            <span className=" mr-2 font-semibold ">
                              {showName(note.commentedByName)}
                            </span>
                            <div>{showLocalDateTime(note.createdOn)}</div>
                            <Row>
                              <Col>
                                <Linkify
                                  className="t-parsed-text"
                                  options={{ defaultProtocol: "https" }}
                                >
                                  {note.notes}
                                </Linkify>
                              </Col>
                            </Row>
                          </Col>
                        </Col>

                        <Col className="text-right">
                          {showDeleteButton(note, index)}
                        </Col>
                      </div>
                    </div>
                  </span>
                </div>
                {notes.length > 1 && index != notes.length - 1 && (
                  <>
                    <hr />
                  </>
                )}
              </div>
            );
          })}
      </>
    );
  };

  const onMentionsInputChange=(e)=> {
    // setCurrentPage(e);
    
    
    setNotesAdded(e.target.value);

  }

  const handleChange=(event, newValue, newPlainTextValue, mentions)=>{
    setNotesAdded(event.target.value);    
    setSelectedMentions(mentions);
  }

  const updatedHandleChange=(event, newValue, newPlainTextValue, mentions)=>{
    setTaSelectedNotes(event.target.value);    
    setSelectedMentions(mentions);
  }

  return (
    <>
      <div className="Container-box">
        {/* <MyEditor/> */}
        <div className="row">
          <div className="col-sm-12">
            <div className="addexperience right">
              <div className="skill-header  mt-2"></div>
              <div>
                <Card>
                  <CardBody>
                    <div className="profile-card-title ">
                      <label>
                        <strong>
                          <h2>Notes</h2>
                        </strong>
                      </label>
                    </div>
                    <div>
                      <div>
                     <MentionsInput
                       
                        
                          rows="4"
                          id="notes"
                          style={mentionsInputStyle}
                          type="textarea"
                          maxLength="255"
                          name="notes"
                          placeholder={"Enter notes..."}
                          // onChange={(e) => onMentionsInputChange(e)}
                          onChange={handleChange}
                          value={notesAdded}
                        >
                          <Mention
                            className="t-user-menstion"
                            displayTransform={(id, display) => `@${display}`}
                            trigger="@"
                            // onAdd={setNotificationuser}
                            // onRemove={handleRemove}
                            style={mentionStyle}
                            data={userMentions}
                            positionSuggestions={(mentions, trigger) => {
                              return {
                                left: 0,
                                top: 0,
                                display: mentions.length > 0 ? "block" : "none",
                              };
                            }}
                          />
                        </MentionsInput>

                        <div></div>
                      </div>

                      {jobStatus !== "CLOSED" && (
                        <Button
                          className="mt-2 mb-4"
                          color="primary"
                          size="sm"
                          outline
                          onClick={addJobNotes}
                        >
                          Add Notes
                        </Button>
                      )}
                    </div>

                    {showNotesList(notesList)}
                  </CardBody>
                </Card>
              </div>
            </div>
            <Row>
              <Colxx className="mt-2">
                <FormGroup>
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    onClick={handlePreviousButton}
                  >
                    <MdOutlineArrowBackIosNew />
                  </Button>
                  <Button className="ml-2" color="primary" size="sm" outline>
                    <span color="primary" outline="true" onClick={doneFunction}>
                      {" "}
                      Done
                    </span>
                  </Button>
                </FormGroup>
              </Colxx>
            </Row>
          </div>
        </div>
      </div>
      <div
        className="modal fade mt-5"
        id="deleteModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <h3>
                Do you want to delete
                <strong> this note</strong>?
              </h3>
            </div>

            <div className="modal-footer p-3">
              <Button
                type="button"
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
              >
                Close
              </Button>
              <Button
                type="button"
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
                onClick={() => {
                  deleteNote();
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade mt-5 t-z-Index"
        id="deleteModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <h3>Do you want to delete notes?</h3>
            </div>

            <div className="modal-footer p-3">
              <Button
                type="button"
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
              >
                Close
              </Button>
              <Button
                type="button"
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
                onClick={() => {
                  deleteNote();
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="mt-5"
        isOpen={modalBasic}
        toggle={() => setModalBasic(!modalBasic)}
      >
        <ModalHeader className="p-3">
          <strong>Update Notes</strong>
        </ModalHeader>
        <ModalBody>
          <MentionsInput
            placeholder={"Enter notes..."}
            maxLength="255"
            // onChange={(e) => setTaSelectedNotes(e.target.value)}
            onChange={updatedHandleChange}
            style={mentionsInputStyle}
            value={taSelectedNotes}
          >
            <Mention
              trigger="@"
              className="pointer"
              // onAdd={setNotificationuser}
              data={userMentions}
              style={mentionStyle}
              displayTransform={(id, display) => `@${display}`}
              positionSuggestions={positionSuggestions}
            />
          </MentionsInput>
        </ModalBody>
        <ModalFooter className="p-3">
          <Button
            className="m-0"
            color="primary"
            size="sm"
            outline
            onClick={UpdateJobnotes}
          >
            Update Notes
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddNotes;
